export const numeric = /\d/
export const specialCharcaters = /[!"#$%&'()*+,-./:;<=>?@[\\\]^_`{|}~]/
export const specialCharactersForDescription = /[^a-zA-Z0-9., ]/g
export const alphabet = /^$|^[A-Za-z ]+$/g
